import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import styled, { keyframes } from "styled-components";
import React, { useState } from "react";
import axios from "axios";

// Animation pour le spinner
const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

// Composant Spinner
const Spinner = styled.div`
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #28a745;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  animation: ${spin} 1s linear infinite;
`;
// End spinner composant

const FooterWrapper = styled.footer`
  background: linear-gradient(to right, #e63946, #046A38);
  color: white;
  padding: 40px 0;
  font-family: Arial, sans-serif;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(to right, #ffd700, #ffed4e, #ffd700);
  }

  @media (max-width: 768px) {
    padding: 30px 0;
  }

  @media (max-width: 576px) {
    padding: 25px 0;
  }
`;

const Container = styled.div`
  width: 90%;
  max-width: 1200px;
  margin: auto;
  padding: 0 15px;

  @media (max-width: 768px) {
    width: 95%;
    padding: 0 10px;
  }

  @media (max-width: 576px) {
    width: 100%;
    padding: 0 8px;
  }
`;

const FooterTop = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 40px;
  gap: 30px;

  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 25px;
  }

  @media (max-width: 768px) {
    margin-bottom: 30px;
    gap: 20px;
  }
`;

const FooterLogo = styled.div`
  max-width: 500px;
  flex: 1;

  p {
    font-size: 16px;
    line-height: 1.6;
    margin-bottom: 30px;
  }

  @media (max-width: 1024px) {
    max-width: 100%;
  }

  @media (max-width: 768px) {
    p {
      font-size: 15px;
      margin-bottom: 20px;
      text-align: left;
    }
  }

  @media (max-width: 576px) {
    p {
      font-size: 14px;
      margin-bottom: 15px;
    }
  }
`;

const SocialNewsletterSection = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 40px;
  flex-wrap: wrap;

  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 25px;
    width: 100%;
  }

  @media (max-width: 768px) {
    gap: 20px;
  }

  @media (max-width: 576px) {
    gap: 15px;
  }
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;

  a {
    color: yellow;
    font-size: 22px;
    transition: all 0.3s ease;
    padding: 8px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 40px;
    min-height: 40px;

    &:hover {
      opacity: 0.8;
      background-color: rgba(255, 255, 255, 0.1);
      transform: translateY(-2px);
    }
  }

  @media (max-width: 768px) {
    justify-content: flex-start;
    gap: 15px;

    a {
      font-size: 20px;
      min-width: 36px;
      min-height: 36px;
    }
  }

  @media (max-width: 576px) {
    gap: 12px;

    a {
      font-size: 18px;
      min-width: 32px;
      min-height: 32px;
    }
  }
`;

const NewsletterContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const NewsletterText = styled.div`
  margin-bottom: 10px;

  h4 {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 5px;
    color: #ffd700;
  }

  p {
    font-size: 14px;
    color: #f1f1f1;
    line-height: 1.4;
  }

  @media (max-width: 768px) {
    text-align: left;

    h4 {
      font-size: 16px;
    }

    p {
      font-size: 13px;
    }
  }

  @media (max-width: 576px) {
    h4 {
      font-size: 15px;
    }

    p {
      font-size: 12px;
    }
  }
`;

const NewsletterForm = styled.form`
  display: flex;
  align-items: center;
  background: white;
  padding: 8px;
  border-radius: 8px;
  max-width: 400px;
  width: 100%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  @media (max-width: 1024px) {
    max-width: 100%;
  }

  @media (max-width: 576px) {
    flex-direction: column;
    padding: 12px;
    gap: 10px;
  }
`;

const EmailInput = styled.input`
  flex: 1;
  padding: 10px;
  border: none;
  outline: none;
  font-size: 14px;
  color: black;
  border-radius: 4px;

  &::placeholder {
    color: #666;
  }

  @media (max-width: 576px) {
    width: 100%;
    padding: 12px;
    font-size: 15px;
  }
`;

const SubscribeButton = styled.button`
  background: #28a745;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;

  &:hover {
    background: #218838;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }

  @media (max-width: 576px) {
    width: 100%;
    padding: 12px 20px;
    font-size: 15px;
  }
`;

const FooterLinks = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 80px;
  width: 50%;

  @media (max-width: 1024px) {
    width: 100%;
    justify-content: space-between;
    gap: 40px;
  }

  @media (max-width: 768px) {
    flex-direction: row;
    justify-content: space-around;
    gap: 20px;
    margin-top: 20px;
  }

  @media (max-width: 576px) {
    flex-direction: column;
    gap: 15px;
    align-items: center;
  }
`;

const FooterColumn = styled.div`
  flex: 1;
  min-width: 150px;

  h4 {
    font-size: 18px;
    margin-bottom: 20px;
    font-weight: bold;
    color: #ffd700;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  li {
    margin-bottom: 15px;
  }

  a {
    color: white;
    text-decoration: none;
    font-size: 15px;
    transition: all 0.3s ease;
    display: inline-block;

    &:hover {
      text-decoration: underline;
      color: #ffd700;
      transform: translateX(5px);
    }
  }

  @media (max-width: 768px) {
    text-align: center;
    
    h4 {
      font-size: 16px;
      margin-bottom: 15px;
    }

    li {
      margin-bottom: 10px;
    }

    a {
      font-size: 14px;
    }
  }

  @media (max-width: 576px) {
    text-align: center;
    margin-bottom: 20px;
    
    h4 {
      font-size: 15px;
      margin-bottom: 12px;
    }

    li {
      margin-bottom: 8px;
    }

    a {
      font-size: 13px;
    }
  }
`;

const Divider = styled.div`
  height: 1px;
  background-color: rgba(255, 255, 255, 0.1);
  margin: 20px 0;
`;

const FooterBottom = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
  text-align: center;

  p {
    margin: 0;
    font-size: 14px;
    color: #f1f1f1;
    opacity: 0.8;
  }

  @media (max-width: 768px) {
    padding: 15px 0;

    p {
      font-size: 13px;
    }
  }

  @media (max-width: 576px) {
    padding: 12px 0;

    p {
      font-size: 12px;
    }
  }
`;

const LogoSection = styled.div`
  display: flex;
  align-items: center;

  .logo-container {
    background-color: white;
    border-radius: 8px;
    padding: 5px 10px;
    margin-right: 15px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  img {
    height: 40px;
    transition: all 0.3s ease;
  }

  &:hover img {
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    justify-content: center;
    margin-bottom: 15px;

    .logo-container {
      margin-right: 0;
    }

    img {
      height: 35px;
    }
  }

  @media (max-width: 576px) {
    img {
      height: 30px;
    }
  }
`;

const FooterMiddleSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }
`;

const LegalLinks = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 30px;
  flex-wrap: wrap;

  a {
    color: white;
    text-decoration: none;
    font-size: 14px;
    transition: all 0.3s ease;

    &:hover {
      text-decoration: underline;
      color: #ffd700;
    }
  }

  @media (max-width: 768px) {
    justify-content: center;
    gap: 20px;
    text-align: center;

    a {
      font-size: 13px;
    }
  }

  @media (max-width: 576px) {
    flex-direction: column;
    gap: 10px;
    align-items: center;

    a {
      font-size: 12px;
      padding: 5px 0;
    }
  }
`;

const Footer = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email) return setError("Veuillez entrer une adresse email.");
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) {
      return setError("Veuillez entrer une adresse email valide.");
    }

    setLoading(true);
    axios
      .post(process.env.React_App_base_url + "newsletter", { email })
      .then((response) => {
        const successRes = response.data.status;
        if (successRes === "success") {
          setSuccess("Inscription à la newsletter avec succès!");
          setError("");
          setEmail("");
        } else {
          setError("Une erreur est survenue. Veuillez réessayer.");
        }
      })
      .catch(() => {
        setError("Une erreur est survenue. Veuillez réessayer.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <FooterWrapper>
      <Container>
        <FooterTop>
          <FooterLogo>
            <p>
              Notre engagement envers l'excellence et la satisfaction client
              nous pousse à fournir des résultats qui élèvent les marques et
              favorisent la croissance.
            </p>

            <SocialNewsletterSection>
              <SocialIcons>
                <Link to="https://www.facebook.com/wilfrid.dedji" target="_blank">
                  <FaFacebookF />
                </Link>
                <Link to="/twitter">
                  <FaXTwitter />
                </Link>
                <Link to="/instagram">
                  <FaInstagram />
                </Link>
                <Link to="/youtube">
                  <FaYoutube />
                </Link>
              </SocialIcons>

              <NewsletterContainer>
                <NewsletterText>
                  <h4>Inscrivez-vous à notre newsletter</h4>
                  <p>
                    Recevez nos dernières mises à jour chaque semaine. Pas de
                    spam.
                  </p>
                </NewsletterText>
                {error && <p style={{ color: "white" }}>👋🏻 {error}</p>}
                {success && <p style={{ color: "yellow" }}>👌🏻 {success}</p>}
                <NewsletterForm onSubmit={handleSubscribe}>
                  <EmailInput  style={{ border: "1px solid #ffd700", borderRadius: "4px", padding: "10px", width: "300px", marginRight: "4px", }}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    name="email"
                    type="email"
                    placeholder="Votre email"
                  />
                  {loading ? <Spinner /> : <SubscribeButton>S'abonner</SubscribeButton>}
                </NewsletterForm>
              </NewsletterContainer>
            </SocialNewsletterSection>
          </FooterLogo>

          <FooterLinks>
            <FooterColumn>
              <h4>Liens rapides</h4>
              <ul>
                <li>
                  <Link to="/">Accueil</Link>
                </li>
                <li>
                  <Link to="/cinef-ec">À propos</Link>
                </li>
                <li>
                  <Link to="/expertises">Services</Link>
                </li>
              </ul>
            </FooterColumn>
            <FooterColumn>
              <h4>Nos Services</h4>
              <ul>
                <li>
                  <Link to="/services/corporate-finance">
                    Services Financiers
                  </Link>
                </li>
                <li>
                  <Link to="/services/conseils-accompagnement-juridique">
                    Services Juridiques
                  </Link>
                </li>
                <li>
                  <Link to="/services/solutions-informatiques-securite">
                    Services IT
                  </Link>
                </li>
              </ul>
            </FooterColumn>
          </FooterLinks>
        </FooterTop>

        <Divider />

        <FooterMiddleSection>
          <LogoSection>
            <div className="logo-container">
              <img src="../assets/images/cinef1.png" alt="CINEF Logo" />
            </div>
          </LogoSection>

          <LegalLinks>
            <Link to="/terms">Conditions d'utilisation</Link>
            <Link to="/privacy">Politique de confidentialité</Link>
            <Link to="/security">Condition Gérale de Vente </Link>
          </LegalLinks>
        </FooterMiddleSection>

        <Divider />

        <FooterBottom>
          <p>Copyright © 2025 Tous droits réservés.</p>
        </FooterBottom>
      </Container>
    </FooterWrapper>
  );
};

export default Footer;